module.exports = __webpack_public_path__ + "img/docs.09715fdb.png";